var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import AbstractUrl from '@/support/AbstractUrl';
import { Component, Model, Watch } from 'vue-property-decorator';
import { Student } from '@/models/Student';
import { Subject } from '@/models/Subject';
import { blackAreaIcons, blackKidIcons, fileIcons } from '@/support/Icon';
import Storage from '@/support/Storage';
import ScoolfolioDialog from '@/views/Users/Student/ScoolfolioDialog';
import { UserFile } from '@/models/UserFile';
import { formatDate } from '@/support/String';
import ErrorHandler from '@/support/ErrorHandler';
import { isEmpty, isArray } from 'lodash';
let Scoolfolio = class Scoolfolio extends AbstractUrl {
    constructor() {
        super(...arguments);
        this.scoolfolioDialog = false;
        this.startDateModal = false;
        this.endDateModal = false;
        this.userFiles = [];
        this.emptyResult = false;
        this.selectedFile = null;
        this.isEditing = false;
        this.topics = [];
        this.selectedArea = '';
        this.selectedTopics = [];
        this.selectedScoolfolioItem = [];
        this.scoolPlan = false;
        this.filterScoolPlan = false;
        this.areaId = null;
        this.topicId = null;
        this.subjectId = null;
        this.filters = {
            topics: [],
            from: '',
            to: '',
        };
        // clean up
        this.selected = null;
        this.options = [];
        this.multiple = true;
        this.isUploading = false;
    }
    get currentCurriculum() {
        return this.$store.state.curriculum;
    }
    get icons() {
        const type = Storage.get('type');
        return type && type.toLowerCase() === 'po' ? blackAreaIcons : blackKidIcons;
    }
    get dialogOptions() {
        const file = this.selectedFile;
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 1, { item: this.$t('portfolio.document') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!file) {
                            return;
                        }
                        // this.selectedFile
                        // .user(this.student)
                        file
                            .setDeleteEndpoint(this.student, file.id)
                            .delete()
                            .then(() => {
                            this.initialize();
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedFile = null;
                    },
                },
            },
        };
    }
    mounted() {
        if (this.$route.query && !isEmpty(this.$route.query)) {
            this.$nextTick(() => {
                this.preFillSelects(this.$route.query);
                this.initialize();
            });
            return;
        }
        this.initialize();
    }
    filter() {
        this.filters.topics = [];
        this.selectedTopics.forEach((selectedTopic) => {
            if (selectedTopic) {
                this.filters.topics.push(selectedTopic);
            }
        });
        let filters = { ...this.filters };
        if (this.selectedArea) {
            filters = { ...filters, ...{ area: this.selectedArea } };
        }
        this.setQueryParams(filters);
        this.initialize();
    }
    initialize() {
        this.emptyResult = false;
        new UserFile()
            .include(['user', 'subject', 'author', 'parent'])
            .user(this.student)
            .filter(this.filters)
            .all()
            .then((userFiles) => {
            if (!userFiles.length) {
                this.emptyResult = true;
            }
            this.userFiles = userFiles;
            this.setTopics();
        });
    }
    setTopics() {
        this.userFiles.forEach((userFile) => {
            if (!userFile.subject || !userFile.subject.parent) {
                return;
            }
            new Subject()
                .include('parent')
                .find(userFile.subject.parent.id)
                .then((topic) => {
                userFile.subject.parent = topic;
            });
        });
    }
    getTopics() {
        this.topics = [];
        const area = this.$store.state.curriculum.subjects.find((area) => {
            return area.id === this.selectedArea;
        });
        if (!area) {
            return;
        }
        area.children.forEach((topic) => {
            this.topics.push(topic);
        });
    }
    getFileIcon(mimeType) {
        if (fileIcons[mimeType]) {
            return fileIcons[mimeType];
        }
        else {
            return fileIcons.other;
        }
    }
    deleteUserFile(file) {
        this.selectedFile = file;
        this.$store.dispatch('openDialog', this.dialogOptions);
    }
    parseDate(date) {
        return formatDate(date);
    }
    async preFillSelects(filters) {
        this.filters.from = filters.from || '';
        this.filters.to = filters.to || '';
        if (filters.topics) {
            this.filters.topics = isArray(filters.topics) ? filters.topics : [filters.topics];
            this.selectedTopics = this.filters.topics;
            if (filters.topics) {
                const topic = await new Subject().include('parent').filter({ depth: 1 }).find(filters.topics[0]);
                if (topic && topic.parent) {
                    this.selectedArea = topic.parent.id;
                }
            }
        }
    }
    selectAreasChanged() {
        this.getTopics();
    }
};
__decorate([
    Model('student', { default: () => new Student() }),
    __metadata("design:type", typeof (_a = typeof Student !== "undefined" && Student) === "function" ? _a : Object)
], Scoolfolio.prototype, "student", void 0);
__decorate([
    Watch('selectedArea'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Scoolfolio.prototype, "selectAreasChanged", null);
Scoolfolio = __decorate([
    Component({
        components: {
            ScoolfolioDialog,
        },
    })
], Scoolfolio);
export default Scoolfolio;
